module.exports = __webpack_public_path__ + "img/student.eec57422.png";